<template>
  <!--Draft-->
  <div v-if="!readOnly">
    <!-- ### First file ### -->
    <div v-if="((!firstUploadFinished || !firstUploadResult)
            && !firstUploadedFile)
            || removeFirstFileResult "
         class="mb-4 flex">
      <button class="btn btn--charcoalgray mr-2 flex" @click="onFirstFileUploadClick">
        <font-awesome-icon icon="file" class="mr-2"/>
        <span>{{ $t('schema.common.action.selectFile') }}</span>
      </button>
      <p class="text-lg flex items-center">Fil 1</p>
      <input type="file"
             style="display: none"
             ref="firstFileInput"
             accept=".xls,.xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
             @change="firstFileUploadChange"/>
    </div>

    <!-- ### Second file ### -->
    <div v-if="!this.isMunicipality
              && (((!secondUploadFinished || !secondUploadResult)
              && !secondUploadedFile)
              || removeSecondFileResult )"
         class="mb-4 flex">
      <button class="btn btn--charcoalgray mr-2" @click="onSecondFileUploadClick">
        <font-awesome-icon icon="file" class="mr-2"/>
        <span>{{ $t('schema.common.action.selectFile') }}</span>
      </button>
      <p class="text-lg flex items-center">Fil 2</p>
      <input type="file"
             style="display: none"
             ref="secondFileInput"
             accept=".xls,.xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
             @change="secondFileUploadChange"/>
    </div>

    <!--Uploaded files-->
    <div v-if="(firstUploadedFile || secondUploadedFile)" class="border-2 rounded mb-4 w-3/4">

      <div class="bg-bluegray-300 p-4 font-medium text-lg">
        <span>{{ $t('schema.common.action.uploadedEconomyFiles') }}</span>
      </div>

      <div class="mb-12 w-full p-4">

        <!-- ### First file ### -->
        <div v-if="firstUploadedFile != null && !removeFirstFileResult || (firstUploadResult && firstUploadedFile && !removeFirstFileResult)" class="mb-2 flex">
          <div class="w-3/4">
            <a :href=firstUploadedFile.url class="py-3 underline text-lightblue-300" title="$t('schema.common.action.download.description')">
              <font-awesome-icon icon="file" class="mr-2"/>
              <span class="mr-4">{{ firstUploadedFile.name }}</span>
            </a>
          </div>
          <!--Delete button-->
          <div class="w-1/4 flex justify-end">
            <button class="mr-2 flex justify-end" @click="removeFirstFile">
              <font-awesome-icon icon="trash" class="mr-2"/>
              <span>{{ $t('schema.common.action.remove') }}</span>
            </button>
          </div>

        </div>

        <!-- ### Second file ### -->
        <div v-if="secondUploadedFile != null  && !removeSecondFileResult || (secondUploadResult && secondUploadedFile && !removeSecondFileResult)" class="mb-2 flex">
          <div class="w-3/4">
            <a :href=secondUploadedFile.url class="py-3 underline text-lightblue-300" title="$t('schema.common.action.download.description')">
              <font-awesome-icon icon="file" class="mr-2"/>
              <span class="mr-4">{{ secondUploadedFile.name }}</span>
            </a>
          </div>
          <!--Delete button-->
          <div class="w-1/4 flex justify-end">
            <button class="mr-2" @click="removeSecondFile">
              <font-awesome-icon icon="trash" class="mr-2"/>
              <span>{{ $t('schema.common.action.remove') }}</span>
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!--Public mode-->
  <div v-else>
    <!--Info text-->
    <div v-if="this.firstUploadedFile && model.properties.infoTextForReader" class="mb-6 mt-6" v-html="model.properties.infoTextForReader">
    </div>
    <!--Uploaded files for download-->
    <div class="border-2 rounded mb-4 w-3/4">
      <div class="bg-bluegray-300 p-4 font-medium text-lg">
        <span>{{ $t('schema.common.action.uploadedEconomyFiles') }}</span>
      </div>
      <ul class="p-4">
        <li>
          <a v-if="this.firstUploadedFile" :href="this.firstUploadedFile.url" class="py-3 underline text-lightblue-300" title="$t('schema.common.action.download.description')">
            <font-awesome-icon icon="file" class="mr-2"/>
            <span>{{ firstUploadedFile.name }}</span>
          </a>
        </li>
        <li>
          <a v-if="this.secondUploadedFile" :href="this.secondUploadedFile.url" class="py-3 underline text-lightblue-300" title="$t('schema.common.action.download.description')">
            <font-awesome-icon icon="file" class="mr-2"/>
            <span>{{ secondUploadedFile.name }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>

import axios from 'axios';

export default {
  props: {
    model: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
      required: false,
    },
    preview: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    firstUploadedFile() {
      if (this.model.properties?.economyFiles?.some((x) => x.id === '1')) {
        return this.model.properties.economyFiles.find((x) => x.id === '1');
      }
      if (this.firstFile) {
        return this.firstFile;
      }
      return null;
    },
    secondUploadedFile() {
      if (this.model.properties?.economyFiles?.some((x) => x.id === '2')) {
        return this.model.properties.economyFiles.find((x) => x.id === '2');
      }
      if (this.secondFile) {
        return this.secondFile;
      }
      return null;
    },
  },
  methods: {
    onFirstFileUploadClick() {
      this.$refs.firstFileInput.click();
    },
    onSecondFileUploadClick() {
      this.$refs.secondFileInput.click();
    },
    firstFileUploadChange(e) {
      const firstFileUploaded = e.target.files || e.dataTransfer.files;
      const [firstFile] = firstFileUploaded;
      this.firstFile = firstFile;
      this.submitFirstFile();
    },
    secondFileUploadChange(e) {
      const secondFileUploaded = e.target.files || e.dataTransfer.files;
      const [secondFile] = secondFileUploaded;
      this.secondFile = secondFile;
      this.submitSecondFile();
    },
    submitFirstFile() {
      if (this.firstFile) {
        const formData = new FormData();
        formData.append('file', this.firstFile);
        axios.post(`${window.location.origin}/api/schema/UploadMunicipalityEconomyFile/${this.model.contentId}/1`, formData)
          .then((response) => {
            this.firstUploadFinished = true;
            this.firstUploadResult = response;
            this.removeFirstFileResult = false;
          }, (error) => {
            this.uploadFirstFinished = true;
            this.uploadFirstResult = false;
            this.statusMessage = error;
          });
      }
    },
    submitSecondFile() {
      if (this.secondFile) {
        const formData = new FormData();
        formData.append('file', this.secondFile);

        axios.post(`${window.location.origin}/api/schema/UploadMunicipalityEconomyFile/${this.model.contentId}/2`, formData)
          .then((response) => {
            this.secondUploadFinished = true;
            this.secondUploadResult = response;
            this.removeSecondFileResult = false;
          }, (error) => {
            this.uploadFinished = true;
            this.uploadResult = false;
            this.statusMessage = error;
          });
      }
    },
    removeFirstFile() {
      axios.post(`${window.location.origin}/api/schema/RemoveEconomyFileMunicipality/${this.model.contentId}/1`, null)
        .then((response) => {
          this.firstFile = null;
          this.firstUploadedFile = null;
          this.removeFirstFileResult = response.data;
        }, (error) => {
          this.statusMessage = error;
        });
    },
    removeSecondFile() {
      axios.post(`${window.location.origin}/api/schema/RemoveEconomyFileMunicipality/${this.model.contentId}/2`, null)
        .then((response) => {
          this.secondFile = null;
          this.secondUploadedFile = null;
          this.removeSecondFileResult = response.data;
        }, (error) => {
          this.statusMessage = error;
        });
    },
  },
  data() {
    return {
      firstFile: null,
      firstUploadFinished: false,
      firstUploadResult: false,
      removeFirstFileResult: false,
      secondFile: null,
      secondUploadFinished: false,
      secondUploadResult: false,
      removeSecondFileResult: false,
    };
  },
};
</script>
